import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'
import store, { persistor } from './store'

// Switch reCAPTCHA to recaptcha.net to avoid TrustArc blocking google.com domains (EXP-311)
;(window as Window & { recaptchaOptions?: { useRecaptchaNet: boolean } }).recaptchaOptions = {
  useRecaptchaNet: true,
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
)
